module.exports = __webpack_public_path__ + "static/img/10.a4a45c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/10.png
// module id = sq4P
// module chunks = 0